// extracted by mini-css-extract-plugin
module.exports = {"hidden":"pageTopButton_hidden__C1Gsn","textEmphasis":"pageTopButton_textEmphasis__pB4g9","topBtn":"pageTopButton_topBtn__2q1mC"};